module.exports = __webpack_public_path__ + "static/media/logo-fundo-1.36803a54.svg";